<template>
  <div id="pageContent" >
    <div>
        <!-- {{dataPageInfos}}
        {{dataPage}} -->
        <div class="headBackground" v-if="dataPageInfos.urlPictureHeader"
            :style="{ 'background-image': 'url('+ dataPageInfos.urlPictureHeader + ')' }"
            style="background-size:100% auto"
        >
        </div>
        <div class="headBackground" v-else>
        </div>
        
        <div class="container">
            <div class="row headContent">
                <div class="col-md-6 headTitle">
                    <p class="mt-2 mb-0">{{this.dataPage.title}}</p>
                    <h1 class="mt-0 mb-0">{{this.dataPage.subTitle}}</h1>
                </div>
                <div class="col-md-3 offset-md-3 headButtons">
                    <a :href="this.dataPage.customizableVar[1].value" target="new" id="btnRounded" class="mt-1" v-if="this.dataPage.customizableVar[1].value">
                        <div class="bg-img">
                            <img src="@/html/elements/megaphone-bleuvert.svg" alt="">
                        </div>
                        Toutes les actualités
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 contentGrid">
                    <v-style>
                        .item-title{
                            border-bottom: {{customizableVar1}} 4px dotted;
                            margin-bottom:10px;
                        }
                        .con-vs-alert{
                            background-color: {{customizableVar1}}50;
                            border: 1px solid {{customizableVar1}};  
                            padding:5px;
                            border-radius:5px
                        }

                        .contentGrid::before {
                            content: " ";
                            background-repeat: no-repeat;
                            background-size: 100%;
                            position: absolute;
                            left: 16px;
                                top: -41px;
                                bottom: 0px;
                                width: 4px;
                            height: calc(100% + 81px);
                            background-color:{{customizableVar1}};
                        }
                        .contentGrid::after {
                            content: " ";
                            background-repeat: no-repeat;
                            background-size: 100%;
                            position: absolute;
                            left: 9px;
                            top: -42px;
                            width: 18px;
                            height: 18px;
                            border-radius:100%;
                            background-color:{{customizableVar1}};
                        }
                        
                        .headTitle::before {
                            content: "";
                            background-repeat: no-repeat;
                            background-size: 100%;
                            position: absolute;
                            left: 10px;
                            top: 23px;
                            bottom: 0px;
                            width: 18px;
                            height: 100%;
                            background-image: url(../elements/afterDropdown-{{customizableVar1}}.svg);
                        }
                        #btnRounded {
                            background-color: {{customizableVar1}};
                        }
                        .headTitle h1{
                            color: {{customizableVar1}};
                        }
                        .content-element h1, .content-element h2 {
                            color: {{customizableVar1}};
                        }
                        .content-element .button{
                            padding: 5px 15px;
                            margin: 0px;
                            background-color: {{customizableVar1}};
                            border: 1px solid {{customizableVar1}}50;  
                            border-radius:100px;
                            text-align:center;
                            text-decoration:none;
                            cursor:pointer
                        }
                        .content-element .button p{
                            padding:0px;
                            margin:0px;
                        }
                        .content-element ul{
                            margin:0px;
                        }
                        .ql-align-center{
                            text-align:center
                        }
                        .ql-align-right{
                            text-align:right
                        }
                        .ql-align-left{
                            text-align:left
                        }
                        p {
                            margin-bottom:0px;
                        }
                        .ql-size-large{
                        font-size: 1.4rem;
                        }
                    </v-style>
                    <div
                        
                        v-for="(item, index) in dataPage.gridLayout"
                        class="content-element"
                        :key="index"
                    >
                        <row-widget
                            v-if="item.type == 'row'"
                            :layout="dataPage.gridLayout"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></row-widget>
                        <col-widget
                            v-if="item.type == 'col'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></col-widget>
                        <text-widget
                            
                            v-if="item.type == 'text'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></text-widget>
                        <text-area-widget
                            v-if="item.type == 'content'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></text-area-widget>
                        <image-widget
                            v-if="item.type == 'image'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></image-widget>
                        <alert-widget
                            v-if="item.type == 'alert'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                            :color="item.color"
                        >
                        </alert-widget>
                        <button-widget
                            v-if="item.type == 'button'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        >
                        </button-widget>
                        <link-widget
                            v-if="item.type == 'link'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        >
                        </link-widget>
                        <title-widget
                            v-if="item.type == 'title'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></title-widget>
                        <quote-widget
                            v-if="item.type == 'quote'"
                            :preview="preview"
                            :contenteditable="contenteditable"
                            :item="item"
                            :itemIndex="index"
                        ></quote-widget>
                    </div>

                </div>
            </div>
        </div> 
    </div>

  </div>
</template>

        


<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";
import { setSubCollection, setSub2Collection } from "@/../script/global";

// CONFIG
import  { themeConfig, irisConfig }  from "@/../siteConfig.js";

import RowWidget from "../editor/RowWidget";
import ColWidget from "../editor/ColWidget";
import TextWidget from "../editor/TextWidget";
import TextAreaWidget from "../editor/TextAreaWidget";
import ImageWidget from "../editor/ImageWidget";
import AlertWidget from "../editor/alertWidget";
import ButtonWidget from "../editor/ButtonWidget";
import LinkWidget from "../editor/LinkWidget";
import TitleWidget from "../editor/TitleWidget";
import QuoteWidget from "../editor/QuoteWidget";
import { GridLayout, GridItem } from "vue-grid-layout";

// For custom error message
import VueRecaptcha from 'vue-recaptcha';
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    lastname: {
      required: 'Veuillez saisir votre nom',
      alpha: 'Your first name may only contain alphabetic characters'
    },
    firstname: {
      required: 'Veuillez saisir votre prénom',
      alpha: 'Your last name may only contain alphabetic characters'
    },
    phone: {
      required: 'Veuillez saisir votre numéro de téléphone',
      alpha: 'Your last name may only contain alphabetic characters'
    },
    email: {
      required: 'Veuillez saisir votre adresse email',
      alpha: 'Your last name may only contain alphabetic characters'
    },
    objet: {
      required: 'Veuillez saisir l\'objet de votre message',
      alpha: 'Your last name may only contain alphabetic characters'
    },
    message: {
      required: 'Veuillez saisir votre message',
      alpha: 'Your last name may only contain alphabetic characters'
    }
  }
}

// register custom messages
Validator.localize('fr', dict)

export default {
  components: { 
    RowWidget,
    ColWidget,
    TextWidget,
    TextAreaWidget,
    ImageWidget,
    AlertWidget,
    ButtonWidget,
    LinkWidget,
    TitleWidget,
    QuoteWidget,
    VueRecaptcha
  },
  name: "page-view",
  props: {
    dataPage:{
        type: Object
    },
  },
  data() {
    return {
        contenteditable: false,
        preview: true,
        irisConfig:irisConfig,

        formContact:{
            dataForm:{
                lastname: '',
                firstname: '',
                phone: '',
                email: '',
                details:[
                    {
                        icon:"",
                        label:"Information destinataire",
                        details:[
                            {
                                label:"Etablissement",
                                value:""
                            },
                            {
                                label:"Service",
                                value:""
                            }
                        ]
                    },
                    {
                        icon:"",
                        label:"Détails du message",
                        details:[
                            {
                                label:"Objet",
                                value:""
                            },
                            {
                                label:"Message",
                                value:""
                            }
                        ]
                    }
                ],
                status:"Non traité",
                addDate:new Date()
            },
            robot: false,
            send:false
        },

        newsList:[],
        agendaList:[],
      
        map: null,
        tileLayer: null,
        mapMarker: [{
            id: 0,
            name: '<b>LYCEE GUSTAVE FLAUBERT</b><br>1 Rue Albert Dupuis<br>76044 Rouen',
            type: 'marker',
            coords: [49.450929, 1.120701],
        }],
    };
  },
  computed:{

    // imgLogo: function () {
    //     if(this.dataPage.customizableVar[0].value.value){
    //         return require('@/html/elements/logo-'+this.dataPage.customizableVar[0].value.value+'.png')
    //     }else{
    //         return require('@/html/elements/logo-0f555d.png')
    //     }
    // },
    // imgUser: function () {
    //     if(this.dataPage.customizableVar[0].value.value){
    //         return require('@/html/elements/user-'+this.dataPage.customizableVar[0].value.value+'.svg')
    //     }else{
    //         return require('@/html/elements/user-0f555d.svg')
    //     }
    // },
    dataPageInfos: function () {
        if(this.dataPage){
            return this.dataPage || ""
        }else{
            return ""
        }
    },

    layout: function () {
        if(this.dataPage.gridLayout.length > 0){
            return this.dataPage.gridLayout || ""
        }else{
            return ""
        }
    },
    customizableVar1: function () {
        if(this.dataPage.customizableVar[0].value){
            return this.dataPage.customizableVar[0].value.value
        }else{
            return "#d17335"
        }
    },
    urlPictureHeader: function () {
        if(this.dataPage.urlPictureHeader){
            return this.dataPage.urlPictureHeader
        }else{
            return require('@/html/elements/bg-header.jpg')
        }
    },
  },
  mounted() {
    if(this.dataPage.id=="PoDyuFuGpdem0OkFNBVm"){
        setTimeout(() => {
            this.initMap();
            this.initMarkers();
        }, 500);
    }else if(this.dataPage.route=="accueil"){
        $(document).ready(function () {
            $('.home-slideshow').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                speed: 500,
                fade: true,
                cssEase: 'linear'
            });
        });
    }else{
       // this.map.remove();
    }

    this.getNews()
    this.geAgenda()
   
  },
  watch: {
    dataPage (newData, old) {
        // react to route changes...
        //console.log("Old data : ", old, "New data : ", newData)
        this.getNews()
        this.geAgenda()
        
        if(newData.id=="PoDyuFuGpdem0OkFNBVm"){
            setTimeout(() => {
                this.initMap();
                this.initMarkers();
            }, 500);
        }else if(this.dataPage.route=="accueil"){
            $(document).ready(function () {
                $('.home-slideshow').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    speed: 500,
                    fade: true,
                    cssEase: 'linear'
                });
            });
        }else{
           this.map.remove();
        }
    }
  }, 
  methods: { 
    submitForm() {
       // if (this.formContact.robot) {
            this.$validator.validateAll().then(result => {
                if(result) {
                    // if form have no errors
                    alert("form submitted!");
                    this.formContact.send = true
                    setSub2Collection(
                        "customers",
                        this.irisConfig.customers,
                        "sites",
                        this.irisConfig.sites,
                        "leads",
                        this.formContact.dataForm,
                    );
                }else{
                    // form have errors
                }
            })
       // }
    },
    onVerify: function (response) {
      if (response) this.formContact.robot = true;
    },
    initMarkers() {
      this.mapMarker.forEach((mapMarkerData) => {
            var marker = L.marker(mapMarkerData.coords).addTo(this.map);
            marker.bindPopup(mapMarkerData.name).openPopup();
      });
        // var marker = L.marker([49.475604, 1.129772]).addTo(this.map);
        //     marker.bindPopup("113 rue Jean Dominique Cassini <br/> 76230 Bois-Guillaume").openPopup();
    },
    initMap() {
      this.map = L.map('mapid').setView([49.450929, 1.120701], 16);
      this.tileLayer = L.tileLayer(
        'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
        }
      );
      this.tileLayer.addTo(this.map);
    },
    getNews(){
        let parentThis=this
        let newsList=[]
        db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('articles')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {

              if(doc.data().deleteDate==null){
                newsList.push(doc.data())
              }
          })
          parentThis.newsList=newsList
        })
        
    },
    geAgenda(){
        let parentThis=this
        let agendaList=[]
        db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('articles')
        .where('associatedCategories', '==', 'Agenda')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {

              if(doc.data().deleteDate==null){
                agendaList.push(doc.data())
              }
          })
          parentThis.agendaList=agendaList
        })
        
    },
  }
};
</script>

<style lang="scss" scopped>
.content-element{
    margin: 10px -10px;
}
.content-element .rowWidget {
    padding-bottom: 20px !important;
}
.content-element h1{
    font-size:2.2rem;
    margin-left: 0px;
}
.content-element h2{
    font-size:1.6rem;
    margin-left: 0px;
}

.headTitle p{
    font-size:1.4rem;
    margin-left: 20px;
}

#pageContent .contact-info{
    font-size: 1.3rem;
    font-weight: 400;
}
#pageContent .contact-info h5{
    overflow: hidden;
    font-weight: 400;
    margin-top:0rem;
    padding-left:1rem;
}
#pageContent .contact-info h5 span{
    width: max-content;
    position: relative;
}
#pageContent .contact-info h5 span:after{
    content:"";
    background-color: #d17335;
    width: 400%;
    height: 2px;
    position: absolute;
    top: 50%;
    right:calc(-400% - 10px);
    border-top-left-radius:4px;
    border-bottom-left-radius:4px
}
#pageContent .contact-info h5 span:before{
    content:"";
    background-color: #d17335;
    width: 8px;
    height: 8px;
    position: absolute;
    top: calc(50% - 3px);
    left:-1rem;
    border-radius:50%
}

#pageContent .contact-info h5.c-1 span:after,
#pageContent .contact-info h5.c-1 span:before{
    background-color: #028985;   
}
#pageContent .contact-info h5.c-2 span:after,
#pageContent .contact-info h5.c-2 span:before{
    background-color: #d17335;
}

#pageContent .contact-info h5.c-3 span:after,
#pageContent .contact-info h5.c-3 span:before{
    background-color: #7a49b0;
}
#pageContent .contact-info .contact-tel.c-1 img .cls-1,
#pageContent .contact-info .contact-tel.c-1 img path {
    fill: #028985 !important;
}
#pageContent .contact-info .contact-tel.c-2 img .cls-1 {
    fill: #d17335 !important;
}
#pageContent .contact-info .contact-tel.c-3 img .cls-1 {
    fill: #7a49b0 !important;
}


#pageContent .contact-info .contact-tel{
    display: flex;
    font-size: 1.5rem;
    align-items: center;
    font-weight: 500;
    margin-bottom:0rem;
}
#pageContent .contact-info .contact-tel div{
    display: flex;
    align-items: center;
}
#pageContent .contact-info .contact-tel img,
#pageContent .contact-info .contact-tel a img,
#pageContent .contact-info .contact-mail img,
#pageContent .contact-info .contact-mail a img{
    max-height: 20px;
    max-width: 25px;
    width: 25px;
    margin-right: 0.5rem
}

#pageContent .contact-info .contact-tel a{
    color:#f1f1f1;
    display: contents;
}

#pageContent .contact-info .contact-mail{
    display: flex;
    font-size: 1.2rem;
    align-items: center;
    font-weight: 500;
    margin-bottom:0rem;
}
#pageContent .contact-info .contact-text{
    font-size:1rem;
    padding-left:35px
}   
#pageContent .contact-social{
    display: flex;
    margin-top:1.5rem
}
#pageContent .contact-social img{
    max-width: 30px;
    margin-right: 0.5rem
}
.form-send{
    position:relative;
    margin:1rem 0rem;
    padding:5rem 0rem;
    text-align: center;
}

.form-send:before, .form-send:after{
    content:"";
    background-color: #d17335;
    width: 100%;
    height: 2px;
    position: absolute;
    top: 0px;
    right:0px;
    border-radius:4px;
}
.form-send:after{
    top:100%
}
.btn-send {
    width: 150px;
    text-align: left;
    color: #ffffff;
    border:none;
    padding: 5px 25px 5px 10px;
    border-bottom-right-radius: 50px;
    align-self: flex-end;    
    position: relative;
    font-size: 1.2rem;
}
.btn-send:hover {
    text-decoration: none;  
}
.btn-send:focus {
    outline: none;    
}

</style>
